module.exports = __webpack_public_path__ + "media/atmospheric-timelapse.e96c6efc.mp3";